import React from "react";
import { store } from "./app/store";
import { Provider } from "react-redux";

import ModalProvider from "./components/Modal/ModalContext";

type Props = {
  children: React.ReactNode;
};

const Providers: React.FC<Props> = ({ children }) => {
  return (
    <Provider store={store}>
      <ModalProvider>{children}</ModalProvider>
    </Provider>
  );
};

export default Providers;
